import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class DicBusinesstypeoptionApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'dicBusinesstypeoption'
    }


    /**
     * 查询字典列表
     * @param bid 
     */
    public getDicOptions(params){
        return this.send(params,"getDicOptions",Methods.GET)
    }

     /**
     * 删除
     * @param ids 
     */
    public delete(ids){
        return this.send({},"delete?ids="+ids,Methods.POST)
    }

    /**
     * 行添加批量保存更新
     * @param param 
     */
    public saveDicOptions(param){
        return this.send(param,"saveDicOptions",Methods.POST)
    }
}